// extracted by mini-css-extract-plugin
export default {"box_cta_btn":"Button_box_cta_btn__RgT22","cta_btn":"Button_cta_btn__-GVit"};